import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SignatureOutlinedSvg from "@ant-design/icons-svg/es/asn/SignatureOutlined";
import AntdIcon from "../components/AntdIcon";
var SignatureOutlined = function SignatureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SignatureOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SignatureOutlined.displayName = 'SignatureOutlined';
}
export default /*#__PURE__*/React.forwardRef(SignatureOutlined);